import { createSlice } from "@reduxjs/toolkit";
import { orderCancel } from "./orderAsyncThunk";

const orderCancelSlice = createSlice({
  name: "order",
  initialState: {
    isLoading: false,
    isSuccess: false,
    payload: "",
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [orderCancel.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [orderCancel.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.isFail = false;
      state.payload = action.payload.message;
    },
    [orderCancel.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isFail = true;
    },
  },
});

export default orderCancelSlice.reducer;
